import { api } from 'utility';
import { getBusinessDealerServiceUrl } from 'URLs';
export function getDealers(params) {
  return api.get(getBusinessDealerServiceUrl(), { params }).then((res) => res.data);
}

export default { getDealers };
